import chroma from "chroma-js";

function colorSimilarity(newColor: chroma.Color, existingColors: Set<any>): boolean {
    for (const color of existingColors) {
        const deltaE = chroma.deltaE(newColor, color);
        if (deltaE < 20) return true;
    }
    return false;
}

/**
 * Generates a list of visually distinct hex colors, excluding specified colors.
 *
 * @param excludedColors - An array of hex color strings to avoid.
 * @returns An array of generated hex color strings.
 */
export const generateDistinctColors = (excludedColors: string[], maxAttempts: number): string[] => {
  
  const excludedSet = excludedColors.length !== 0 ? new Set(excludedColors.map(color => color.toLowerCase())) : new Set();
  const amount = 12;
  let generatedColors: string[] = new Array(amount * 3);

  let idx = 0;
  let attempts = 0;

  while (generatedColors.filter(x => x !== undefined).length < amount * 3 && attempts < maxAttempts) {
    const randomColor = chroma.random();
    
    attempts ++;

    if (colorSimilarity(randomColor, excludedSet)) {
        continue
    }
    
    generatedColors[idx] = randomColor.hex()
    excludedSet.add(randomColor.hex());

    const colorScale = chroma.scale([randomColor.hex(), "#fff"])
    
    for(let i = 1; i < 3; i++) {
        const newColor = colorScale(0.3 * i).hex()
        generatedColors[idx + i * 12] = newColor
    }

    idx ++;
  }
  
  generatedColors = generatedColors.filter(c => c !== undefined)

  if (generatedColors.length < amount) {
    console.warn(
      `Could not generate ${amount} distinct colors. 
       Only ${generatedColors.length} were generated.`
    );
  }

  return generatedColors;
};